module.exports = __webpack_public_path__ + "img/xiezhen2.686819a5.jpg";